import { render, staticRenderFns } from "./InformacoesGerais.vue?vue&type=template&id=81c7ee3c&scoped=true"
import script from "./InformacoesGerais.vue?vue&type=script&lang=js"
export * from "./InformacoesGerais.vue?vue&type=script&lang=js"
import style0 from "./InformacoesGerais.vue?vue&type=style&index=0&id=81c7ee3c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "81c7ee3c",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
import { VCardText } from 'vuetify/lib/components/VCard';
import { VCardTitle } from 'vuetify/lib/components/VCard';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VCard,VCardText,VCardTitle,VCol,VRow})
